import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import env_constants from "../Constants";

function ProductImage({ galleryMedia, featuredImage }) {
  const [selectedImage, setSelectedImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const productimagenotfound = "/assets/images/product-image-not-found.webp";
  const [images, setImages] = useState([]); // Store all images for slider

  useEffect(() => {
    let mediaImages = [];

    if (galleryMedia) {
      mediaImages = galleryMedia
        .split(",")
        .map((img) => env_constants.API_BASE_PUBLIC_URL + img.trim());
    }

    setImages(mediaImages); // Remove featuredImage from the slider but keep it as main image

    // Set main image
    if (featuredImage) {
      setSelectedImage(env_constants.API_BASE_PUBLIC_URL + featuredImage);
    } else if (mediaImages.length > 0) {
      setSelectedImage(mediaImages[0]);
    } else {
      setSelectedImage(productimagenotfound);
    }
  }, [galleryMedia, featuredImage]);

  const handleImageClick = (newImageUrl) => {
    setSelectedImage(newImageUrl);
  };

  const handleNextClick = () => {
    if (currentIndex + 3 < images.length) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      setSelectedImage(images[newIndex]);
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      setSelectedImage(images[newIndex]);
    }
  };

  const handleImageError = () => {
    setSelectedImage(productimagenotfound);
  };

  return (
    <div className="container image_size">
      <img
        src={selectedImage}
        alt="Selected Product"
        onError={handleImageError}
        style={{ display: "none" }}
      />
      <div
        className="single-product_image"
        style={{ backgroundImage: `url(${selectedImage})` }}
      ></div>

      <div className="section_images" style={{ display: "flex", alignItems: "center" }}>
        {currentIndex > 0 && images.length > 3 && (
          <FaArrowLeft className="nav-icon" onClick={handlePrevClick} />
        )}
        {images.slice(currentIndex, currentIndex + 3).map((image, index) => (
          <img
            key={index}
            src={image}
            className={`product_section_image ${selectedImage === image ? "selected" : ""}`}
            alt={`Section ${index + 1}`}
            onClick={() => handleImageClick(image)}
            onError={(e) => (e.target.src = productimagenotfound)}
            style={{ cursor: "pointer", margin: "0 5px" }}
          />
        ))}
        {currentIndex + 3 < images.length && (
          <FaArrowRight className="nav-icon" onClick={handleNextClick} />
        )}
      </div>
    </div>
  );
}

export default ProductImage;
